import { fetcherClient } from 'shared/lib/fetcher'

/**
 * Retrieves the user's profile details.
 *
 * @returns {Promise} A promise that resolves with the server's response.
 */
export const getUserDetail = () => {
  return fetcherClient.get('auth/user/profile')
}
